import {
  Spacing
} from 'UI'

export default theme => ({
  concernedAudiencesGroup: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: ({ noPaper }) => noPaper ? 0 : Spacing(5)
  },
  concernedAudiencesText: {
    overflow: 'hidden',
    transition: 'all 0.15s ease',
    position: 'relative'
  },
  icon: {
    paddingLeft: 8,
    fontSize: 16
  },
  iconCheck: {
    color: theme.secondary[0],
    paddingRight: 2,
    fontSize: 16
  },
  concernedAudienceItem: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: 4
  },
  showMore: {
    alignItems: 'end'
  }
})
